<template>
  <q-dialog
    v-model="isVisible"
    persistent
    :maximized="false"
    transition-show="scale"
    transition-hide="scale"
  >
    <q-card class="gallery-modal">
      <q-card-section class="gallery-modal__title">
        <div class="text-h6 text-center">
          {{ $t("imageNavigation.thumbnailPreparation.title") }}
        </div>
      </q-card-section>

      <q-card-section class="gallery-modal__body">
        <div class="text-center">
          <p>{{ $t("imageNavigation.thumbnailPreparation.body1_blurred") }}</p>
          <p>{{ $t("imageNavigation.thumbnailPreparation.body2_blurred") }}</p>
        </div>
      </q-card-section>

      <q-card-actions class="gallery-modal__actions">
        <p class="gallery-modal__button" @click="backToSelectionMode">
          <img src="@/assets/icons/back_arrow.svg" alt="back" /><span
            class="q-ml-sm gallery-modal__button--text"
            >{{ $t("imageNavigation.thumbnailPreparation.button") }}</span
          >
        </p>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  toggleActive: {
    type: Function,
    required: true,
  },
});
const emit = defineEmits(["update:modelValue"]);

const isVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const backToSelectionMode = () => {
  props.toggleActive(0);
  emit("update:modelValue", false);
};
</script>

<style lang="scss" scoped>
.gallery-modal {
  min-width: 400px;
  max-width: 600px;
  width: 90vw;
  background-color: var(--color-dark-bg-primary);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: white;

  &__title {
    padding: 24px 24px 16px 24px;
    text-align: center;

    .text-h6 {
      font-weight: 600;
      font-size: 20px;
    }
  }

  &__body {
    padding: 0 24px 24px 24px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;

    &--highlight {
      font-weight: 500;
    }
  }

  &__actions {
    padding: 16px 24px 24px 24px;
    justify-content: center;
    gap: 12px;
  }

  &__button {
    color: var(--color-gree300);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: var(--color-viewer-green-light);
      text-decoration: none;
    }

    &:active {
      color: var(--color-viewer-green-dark);
      transform: scale(0.98);
    }

    &--text {
      font-size: 16px;
    }
  }
}
</style>
